var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"namePlate  ",class:[_vm.isBig ? 'big' : ''],style:(("background: " + _vm.background + ";font-size: " + _vm.fontSize))},[_vm._v(" "+_vm._s(_vm.nameplate)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }